import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <nav className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="separator">|</span>
          <Link to="/terms">Terms of Service</Link>
        </nav>

        <div className="footer-copyright">
          <span>© {new Date().getFullYear()} wrappr. All rights reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
